import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {AutoComplete} from "primereact/autocomplete";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import {InputNumber} from "primereact/inputnumber";
import {DataTable} from "primereact/datatable";
import {Column} from 'primereact/column';
import {InputMask} from "primereact/inputmask";
import {SplitButton} from "primereact/splitbutton";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import moment from "moment/moment";

const WorksheetFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState([]);
  const [selectedPartnerName, setSelectedPartnerName] = useState('');
  const [companies, setCompanies] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [schemas, setSchemas] = useState([]);
  const [units, setUnits] = useState([]);
  const [formData, setFormData] = useState({
    deadline: new Date()
  });
  const [itemFormData, setItemFormData] = useState({});
  const [items, setItems] = useState([]);
  const [itemFields, setItemFields] = useState([]);
  const [itemFieldOptions, setItemFieldOptions] = useState([]);
  const [itemScema, setItemScema] = useState('');
  const [collectionFormData, setCollectionFormData] = useState({});
  const [collectionFields, setCollectionFields] = useState([]);
  const [collectionFieldOptions, setCollectionFieldOptions] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (id && id !== 'undefined') {
      axios.patch(process.env.REACT_APP_API_HOST + "/api/v2/project-shortcut-dto/" + id,
        data,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProjectList: true})
          setFormData(response.data.data)
          setItems(response.data.data.children_id)
          setItemFormData({
            project: response.data.data.persisted_project_id
          })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      axios.post(process.env.REACT_APP_API_HOST + "/api/v2/project-shortcut-dto",
        data,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProjectList: true})
          setFormData(response.data.data)
          setItems(response.data.data.children_id)
          setItemFormData({
            project: response.data.data.persisted_project_id
          })
          history.push('/project/worksheet/update/' + response.data.data.shortcut_dto_id)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-ml-2"
                tooltip="Módosítás"
                type={"button"}
                loading={loading}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  setLoading(true)
                  axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dto-info/" + rowData.project_item_schema.shortcut_dto_class.split("\\").pop(),
                    {
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                        'App-Network': localStorage.getItem("networkId")
                      }
                    })
                    .then(response => {
                      let _options = []
                      response.data.editable_fields.map(field => {
                        if (field.type.includes("Entity")) {
                          axios.get(process.env.REACT_APP_API_HOST + "/api/v2/" + field.entity_class.split("\\").pop().toLowerCase(),
                            {
                              params: {},
                              headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                'App-Network': localStorage.getItem("networkId")
                              }
                            })
                            .then(response => {
                              _options[field.name] = response.data.data.items
                            })
                            .catch(error => {
                              if (error.response.status === 404) {
                                axios.get(process.env.REACT_APP_API_HOST + "/" + field.entity_class.split("\\").pop().toLowerCase(),
                                  {
                                    params: {},
                                    headers: {
                                      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                      'App-Network': localStorage.getItem("networkId")
                                    }
                                  })
                                  .then(response => {
                                    _options[field.name] = response.data.items
                                  })
                                  .catch(error => {

                                  })
                              }
                            })
                          setTimeout(() => {
                            setItemScema(rowData.project_item_schema.shortcut_dto_class.split("\\").pop())
                            setItemFields(response.data.editable_fields)
                            setItemFieldOptions(_options)
                            setItemFormData({
                              ...rowData,
                              project: rowData.project.id,
                              project_item_schema: rowData.project_item_schema.id
                            })
                            setLoading(false)
                            history.push('/project/worksheet/update/' + id + '?update=projectItem' + '&itemId=' + rowData.item_shortcut_dto_id + '&itemSchema=' + rowData.project_item_schema.shortcut_dto_class.split("\\").pop())
                          }, 2000)
                        }
                      })
                    })
                    .catch(error => {

                    })
                }}/>
        {/*<Button type="button" icon="pi pi-trash" className="p-button-danger p-button-sm p-ml-2"*/}
        {/*        onClick={() => {*/}
        {/*          let _children = formData.children_id*/}
        {/*          const __children = _children.filter(item => item.persisted_project_item_id !== rowData.persisted_project_item_id);*/}
        {/*          setFormData({*/}
        {/*            ...formData,*/}
        {/*            children_id: __children*/}
        {/*          })*/}
        {/*          setItems(__children)*/}
        {/*          onSubmit(*/}
        {/*            {*/}
        {/*              ...formData,*/}
        {/*              children_id: __children*/}
        {/*            }*/}
        {/*          )*/}
        {/*        }}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  useEffect(() => {
    setLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/currency",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setCurrencies(response.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/company",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setCompanies(response.data.items)
        if (response.data?.items[0]) {
          setFormData({
            ...formData,
            company: response.data.items[0].id
          })
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/technology",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setTechnologies(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/unit",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setUnits(response.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-item-schema",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setSchemas(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_CURRENCY_DEFAULT) {
      setFormData({
        ...formData,
        currency: process.env.REACT_APP_CURRENCY_DEFAULT
      })
    }
  }, [currencies])

  useEffect(() => {
    if(id && id !== 'undefined') {
      setLoading(true)
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-shortcut-dto/" + id,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          let _formData = response.data.data
          axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dto-info/" + window.App.urlVars().itemSchema,
            {
              params: {},
              headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                'App-Network': localStorage.getItem("networkId")
              }
            })
            .then(response => {
              let _options = []
              response.data.editable_fields.map(field => {
                if (field.type.includes("Entity")) {
                  axios.get(process.env.REACT_APP_API_HOST + "/api/v2/" + field.entity_class.split("\\").pop().toLowerCase(),
                    {
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                        'App-Network': localStorage.getItem("networkId")
                      }
                    })
                    .then(response => {
                      _options[field.name] = response.data.data.items
                    })
                    .catch(error => {
                      if (error.response.status === 404) {
                        axios.get(process.env.REACT_APP_API_HOST + "/" + field.entity_class.split("\\").pop().toLowerCase(),
                          {
                            params: {},
                            headers: {
                              'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                              'App-Network': localStorage.getItem("networkId")
                            }
                          })
                          .then(response => {
                            _options[field.name] = response.data.items
                          })
                          .catch(error => {
                            setLoading(false)
                          })
                      }
                    })
                  setTimeout(() => {
                    setItemFields(response.data.editable_fields)
                    setItemFieldOptions(_options)
                    let _item = _formData?.children_id?.filter(item => item.item_shortcut_dto_id	 === window.App.urlVars().itemId)
                    if(_item && _item[0]) {
                      setItemFormData({
                        ..._item[0]
                      })
                      setItemScema(_item[0].project_item_schema.shortcut_dto_class.split("\\").pop())
                      setLoading(false)
                    }
                  }, 2000)
                }
              })
            })
            .catch(error => {
              setLoading(false)
            })
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.urlVars().itemSchema])

  useEffect(() => {
    if(window.App.urlVars().partnerName) {
      setFormData({
        ...formData,
        partnerName: decodeURIComponent(window.App.urlVars().partnerName),
        partner: window.App.urlVars().partnerId
      })
    }
  }, [window.App.urlVars().partnerName])

  useEffect(() => {
    if(formData.partner?.id) {
      setFormData({
        ...formData,
        partnerName: formData.partner?.name,
        partner: formData.partner?.id
      })
    }
  }, [formData.partner])

  useEffect(() => {
    if (id && action === 'update') {
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-shortcut-dto/" + id,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setSelectedPartnerName(response.data.data.partner.name)
          setItemFormData({
            ...itemFormData,
            project: response.data.data.persisted_project_id
          })
          setItems(response.data.data.children_id)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [id])

  return (
    <div className={"worksheet-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <Panel className={""}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="company" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="company"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Szállító</label>
                    <span className={"p-d-block"}>
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    company: e.target.value
                                  })
                                }}
                                value={formData?.company?.id || formData.company}
                                options={companies}
                                optionLabel="name"
                                optionValue="id"
                                id={"comapny"}
                                emptyMessage={"Még nincs cég..."}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"} id="partner_field">
                <Field name="partner" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="partner"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Partner</label>
                    <span className={"p-field p-inputgroup"}>
                      <Button type="button" className={"p-button"}
                              onClick={() => {
                                let _params = '?'
                                Object.entries(window.App.urlVars()).map(([key, value]) => {
                                  _params += key + '=' + value + '&'
                                })
                                _params += 'search=partner'
                                history.push('/project/' + entity + '/' + action + '/' + id + _params )
                              }}>
                        <i className={"pi pi-search"}></i>
                      </Button>
                      <AutoComplete value={formData.partnerName}
                                    id={"partner"}
                                    suggestions={partners}
                                    forceSelection
                                    completeMethod={(event) => {
                                      setLoading(true);
                                      axios.get(process.env.REACT_APP_API_HOST + "/partner?" + JSON.stringify({filters: {name: {value: event.query}}}),
                                        {
                                          params: {},
                                          headers: {
                                            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                            'App-Network': localStorage.getItem("networkId")
                                          }
                                        })
                                        .then(response => {
                                          let _partners = []
                                          if(response.data.items && response.data.items[0]) {
                                            response.data.items.map((partner, index) => {
                                              _partners.push({
                                                ...partner,
                                                name: partner.name + " (" + partner.addressPostalCode + " " + partner.addressCity + ", " + partner.addressDetail + ")",
                                              })
                                            })
                                            setPartners(_partners)
                                          } else {
                                            window.App.toastShow('warn', 'Figyelem!', 'Nem található partner a megadott adatokkal.');
                                          }
                                        })
                                        .catch(error => {
                                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                        })
                                        .finally(() => {
                                          setLoading(false);
                                        })
                                    }}
                                    field={"name"}
                                    delay="1000"
                                    placeholder={"Keresés gépeléssel..."}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                    onSelect={(e) => {
                                      setFormData({
                                        ...formData,
                                        partner: e.value.id,
                                        partnerName: e.value,
                                      })
                                    }}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        partner: e.value.id,
                                        partnerName: e.value,
                                      })
                                    }}
                                    onClear={(e) => {
                                      setFormData({
                                        ...formData,
                                        partner: null,
                                        partnerName: null,
                                      })
                                    }}
                      />
                               <Button type="button" className={"p-button"}
                                       onClick={() => {
                                         history.push('/project/' + entity + '/' + action + '/' + id + '?create=partner')
                                       }}>
                                <i className={"pi pi-plus"}></i>
                              </Button>
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="deadline" render={({input, meta}) => (
                  <span className="p-field p-fluid">
                    <label htmlFor="deadline"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Határidő</label>
                    <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"deliveryDate"}
                                       mask={"9999-99-99"}
                                       placeholder={"ÉÉÉÉ-HH-NN"}
                                       value={moment.utc(formData.deadline).local().format('YYYY-MM-DD')}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             deadline: new Date(e.value)
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.deadline}
                                      locale="hu"
                                      dateFormat={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          deadline: e.value
                                        })
                                      }}/>
                    </div>
                    {getFormErrorMessage(meta)}
                  </span>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="name" render={({input, meta}) => (
                  <span className="p-field p-fluid">
                    <label htmlFor="name"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Megnevezés</label>
                    <span className={"p-d-block"}>
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </span>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="custom_id" render={({input, meta}) => (
                  <span className="p-field p-fluid">
                    <label htmlFor="custom_id"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Egyedi hivatkozás</label>
                    <span className={"p-d-block"}>
                      <InputText id="custom_id" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     custom_id: e.target.value
                                   })
                                 }}
                                 value={formData.custom_id}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </span>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="currency" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="currency"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Pénznem</label>
                    <span className={"p-d-block"}>
                              <Dropdown {...input}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            currency: e.target.value
                                          })
                                        }}
                                        value={formData.currency}
                                        options={currencies}
                                        optionLabel="code"
                                        optionValue="code"
                                        id={"currency"}
                                        emptyMessage={"Még nincs pénznem..."}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 "}>
                <Field name="note" render={({input, meta}) => (
                  <span className="p-field p-fluid">
                    <label htmlFor="note"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Megjegyzés</label>
                    <span className={"p-d-block"}>
                      <InputText id="note" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     note: e.target.value
                                   })
                                 }}
                                 value={formData.note}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </span>
                )}/>
              </div>
            </div>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>

              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
                <Button type="submit" label="Mentés"
                        loading={loading}
                        icon={"pi pi-check"}
                        className="p-button-success p-ml-2"/>
              </div>
            </div>
          </Panel>

          {id && id !== 'undefined' &&
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <h3 className={"p-m-0 p-p-0"}>
                    <i className={"pi pi-list"}></i> Tételek
                  </h3>
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                  <SplitButton label="Új tétel"
                               id="buttonItemAdd"
                               type="button"
                               loading={loading}
                               disabled={!id}
                               onClick={() => {
                                 setItemFields([])
                                 setItemFieldOptions([])
                                 setCollectionFields([])
                                 document.getElementById('buttonItemAdd').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                               }}
                               icon="pi pi-plus"
                               className={"p-button-success p-ml-md-2"}
                               model={schemas.map(schema => {
                                 return (
                                   {
                                     label: schema.name,
                                     command: () => {
                                       setLoading(true);
                                       axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dto-info/" + schema.shortcut_dto_class.split("\\").pop(),
                                         {
                                           params: {},
                                           headers: {
                                             'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                             'App-Network': localStorage.getItem("networkId")
                                           }
                                         })
                                         .then(response => {
                                           if(response && response.data) {
                                             setItemScema(schema.shortcut_dto_class.split("\\").pop())
                                             setItemFields(response.data.editable_fields)
                                             let _options = []
                                             let _collectionFields = []
                                             let _collectionFieldOptions = []
                                             response.data.editable_fields.map(field => {
                                               console.log(field)
                                               if (field.type.includes("Entity")) {
                                                 let query = ''
                                                 if (schema.shortcut_dto_class.split("\\").pop().includes("SubcontractorSID")) {
                                                   query += '?search[subcontractor][operator]==&search[subcontractor][value]=1'
                                                 }
                                                 axios.get(process.env.REACT_APP_API_HOST + "/api/v2/" + field.entity_class.split("\\").pop().toLowerCase() + query,
                                                   {
                                                     params: {},
                                                     headers: {
                                                       'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                                       'App-Network': localStorage.getItem("networkId")
                                                     }
                                                   })
                                                   .then(response => {
                                                     _options[field.name] = response.data.data.items
                                                   })
                                                   .catch(error => {
                                                     if (error.response.status === 404) {
                                                       axios.get(process.env.REACT_APP_API_HOST + "/" + field.entity_class.split("\\").pop().toLowerCase() + query,
                                                         {
                                                           params: {},
                                                           headers: {
                                                             'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                                             'App-Network': localStorage.getItem("networkId")
                                                           }
                                                         })
                                                         .then(response => {
                                                           _options[field.name] = response.data.items
                                                         })
                                                         .catch(error => {

                                                         })
                                                     }
                                                   })
                                               }
                                               if (field.type.includes("Collection")) {
                                                 axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dto-info/" + field.entity_class.split("\\").pop(),
                                                   {
                                                     params: {},
                                                     headers: {
                                                       'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                                       'App-Network': localStorage.getItem("networkId")
                                                     }
                                                   })
                                                   .then(response => {
                                                     _collectionFields = response.data.editable_fields
                                                     response.data.editable_fields.map(field => {
                                                       if (field.type.includes("Entity")) {
                                                         axios.get(process.env.REACT_APP_API_HOST + "/api/v2/" + field.entity_class.split("\\").pop().toLowerCase(),
                                                           {
                                                             params: {},
                                                             headers: {
                                                               'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                                               'App-Network': localStorage.getItem("networkId")
                                                             }
                                                           })
                                                           .then(response => {
                                                             _collectionFieldOptions[field.name] = response.data.data.items
                                                           })
                                                           .catch(error => {
                                                             if (error.response.status === 404) {
                                                               axios.get(process.env.REACT_APP_API_HOST + "/" + field.entity_class.split("\\").pop().toLowerCase(),
                                                                 {
                                                                   params: {},
                                                                   headers: {
                                                                     'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                                                     'App-Network': localStorage.getItem("networkId")
                                                                   }
                                                                 })
                                                                 .then(response => {
                                                                   _collectionFieldOptions[field.name] = response.data.items
                                                                 })
                                                                 .catch(error => {

                                                                 })
                                                             }
                                                           })
                                                       }
                                                     })
                                                   })
                                                   .catch(error => {

                                                   })
                                               }
                                             })
                                             let _project = itemFormData.project
                                             if (!_project) {
                                               axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-shortcut-dto/" + id,
                                                 {
                                                   params: {},
                                                   headers: {
                                                     'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                                     'App-Network': localStorage.getItem("networkId")
                                                   }
                                                 })
                                                 .then(response => {
                                                   _project = response.data.data.persisted_project_id
                                                 })
                                                 .catch(error => {

                                                 })
                                                 .finally(() => {

                                                 })
                                             }
                                             setTimeout(() => {
                                               setCollectionFields(_collectionFields)
                                               setCollectionFieldOptions(_collectionFieldOptions)
                                               setItemFormData({
                                                 name: schema.name,
                                                 project: _project,
                                                 project_item_schema: schema.id,
                                                 financial_unit: units[0].id,
                                                 production_unit: units[0].id
                                               })
                                               setItemFieldOptions(_options)
                                               setLoading(false)
                                               history.push('/project/worksheet/update/' + id + '?create=projectItem')
                                             }, 2000)
                                           }
                                         })
                                         .catch(error => {
                                           console.log(error)
                                           window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                         })
                                     }
                                   }
                                 )
                               })}/>
                </div>
              </div>
              <DataTable size={localStorage.getItem('scale')} value={items}
                         emptyMessage="Nincs találat."
                         autoLayout={true}
                         responsiveLayout="scroll"
                         stripedRows
                         className={"p-mb-3"}
              >
                <Column field="name" header="Megnevezés"></Column>
                <Column field="technology.name" header="Technologia"></Column>
                <Column field="financial_quantity" header="Pénzügy mennyiség" className={"p-text-right"}
                        body={(rowData) => {
                          return (
                            <>{rowData?.financial_quantity} {rowData?.financial_unit?.name}</>
                          )
                        }}
                ></Column>
                <Column field="production_quantity" header="Gyártás mennyiség" className={"p-text-right"}
                        body={(rowData) => {
                          return (
                            <>{rowData?.production_quantity} {rowData?.production_unit?.name}</>
                          )
                        }}></Column>
                <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
              </DataTable>
              <Dialog visible={window.App.urlVars().create === 'projectItem' || window.App.urlVars().update === 'projectItem'}
                      style={{width: '750px'}}
                      header="Tétel hozzáadása"
                      modal
                      onHide={() => {
                        history.go(-1)
                      }}>
                <div className={"p-grid"}>
                  {itemFields && itemFields[0] &&
                    <>
                      {itemFields.map((field, index) => {
                        if (field.type.includes("Text")) {
                          return (
                            <>
                              <div className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={field.name}>{t(field.name)}</label>
                                  <span className="p-d-block">
                                      <InputText id={field.name}
                                                 autoFocus={index === 0}
                                                 onChange={(e) => {
                                                   setItemFormData({
                                                     ...itemFormData,
                                                     [field.name]: e.target.value
                                                   })
                                                 }}
                                                 value={itemFormData[field.name]}
                                      />
                                    </span>
                                </div>
                              </div>
                            </>
                          )
                        }
                        if (field.type.includes("Integer")) {
                          return (
                            <>
                              <div className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={field.name}>{t(field.name)}</label>
                                  <span className="p-d-block">
                                      <InputNumber id={field.name}
                                                   autoFocus={index === 0}
                                                   onChange={(e) => {
                                                     setItemFormData({
                                                       ...itemFormData,
                                                       [field.name]: e.value
                                                     })
                                                   }}
                                                   value={itemFormData[field.name]}
                                      />
                                    </span>
                                </div>
                              </div>
                            </>
                          )
                        }
                        if (field.type.includes("Entity") && field.name !== "project" && field.name !== "project_item_schema") {
                          return (
                            <>
                              <div className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={field.name}>{t(field.name)}</label>
                                  <span className="p-d-block">
                                  <Dropdown
                                    onChange={(e) => {
                                      setItemFormData({
                                        ...itemFormData,
                                        [field.name]: e.target.value
                                      })
                                    }}
                                    options={itemFieldOptions[field.name]}
                                    value={itemFormData[field.name]?.id || itemFormData[field.name]}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={field.name}
                                    emptyMessage={"Nincs találat..."}
                                  />
                                </span>
                                </div>
                              </div>
                            </>
                          )
                        }
                      })}
                    </>
                  }
                </div>
                {collectionFields && collectionFields[0] &&
                  <>
                    <div className={"p-grid p-mt-1"}>
                      {collectionFields.map((field, index) => {
                        if (field.type.includes("Text") || field.type.includes("Entity")) {
                          return (
                            <div className={"p-col p-col-align-center"}>
                              {field.name.toUpperCase()}
                            </div>
                          )
                        }
                      })}
                      <div className={"p-col-1 p-text-right"}></div>
                    </div>
                    <hr />
                  </>
                }
                {itemFormData.items && itemFormData.items[0] &&
                  <>
                    {itemFormData.items.map((item, index) => {
                      if (item.marked_to_delete !== true) {
                        return (
                          <div className={"p-grid p-mt-1"}>
                            {Object.entries(item).map(([key, value]) => {
                              let _options = collectionFieldOptions[key]
                              let _name = ''
                              if (_options && _options[0]) {
                                const selectedOption = _options.find(option => option.id === value);
                                _name = selectedOption ? selectedOption.name : "Nem található";
                              }
                              if(!key.includes("s_i_d")) {
                                return (
                                  <div className={"p-col p-col-align-center p-py-0"}>
                                    {_name || value?.name || value}
                                  </div>
                                )
                              }
                            })}
                            <div className={"p-col-1 p-text-right p-col-align-center p-py-0"}>
                              {/*<Button type="button" icon="pi pi-pencil" className="p-button-warning p-button-sm p-ml-2"*/}
                              {/*        disabled*/}
                              {/*        onClick={() => {*/}
                              {/*        }}*/}
                              {/*/>*/}
                              <Button type="button" icon="pi pi-trash" className="p-button-danger p-button-sm p-ml-2"
                                      onClick={() => {
                                        const updatedItems = (itemFormData.items || []).map((item, i) => {
                                          return i === index ? {...item, marked_to_delete: true} : item;
                                        });
                                        setItemFormData({
                                          ...itemFormData,
                                          items: updatedItems,
                                        });
                                      }}
                              />
                            </div>
                          </div>
                        )
                      }
                    })}
                    <hr/>
                  </>
                }
                {collectionFields && collectionFields[0] &&
                  <div className={"p-grid p-mt-1"}>
                    {collectionFields.map((field, index) => {
                      if (field.type.includes("Text")) {
                        return (
                          <div className={"p-col"}>
                            <div className="p-field p-fluid">
                              <span className="p-d-block">
                                <InputText id={field.name}
                                           disabled={!itemFormData.name}
                                           onChange={(e) => {
                                             setCollectionFormData({
                                               ...collectionFormData,
                                               [field.name]: e.target.value
                                             })
                                           }}
                                           value={collectionFormData[field.name]}
                                />
                              </span>
                            </div>
                          </div>
                        )
                      }
                      if (field.type.includes("Entity")) {
                        return (
                          <>
                            <div className={"p-col "}>
                              <div className="p-field p-fluid">
                                <span className="p-d-block">
                                  <Dropdown
                                    disabled={!itemFormData.name}
                                    onChange={(e) => {
                                      setCollectionFormData({
                                        ...collectionFormData,
                                        [field.name]: e.target.value
                                      })
                                    }}
                                    options={collectionFieldOptions[field.name]}
                                    value={collectionFormData[field.name]?.id || collectionFormData[field.name]}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={field.name}
                                    emptyMessage={"Nincs találat..."}
                                  />
                                </span>
                              </div>
                            </div>
                          </>
                        )
                      }
                    })}
                    <div className={"p-col-1 p-text-right"}>
                      <div className="p-field p-fluid">
                        <span className="p-d-block">
                           <Button type="button" icon="pi pi-plus" className="p-button-success p-button-sm w-100"
                                   disabled={!itemFormData.name}
                                   onClick={() => {
                                     setItemFormData({
                                       ...itemFormData,
                                       items: [
                                         ...(itemFormData.items || []),
                                         collectionFormData
                                       ]
                                     })
                                   }}
                           />
                        </span>
                      </div>
                    </div>
                  </div>
                }
                <div className={"p-grid p-mt-1"}>
                  <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                    <Button type="button" label="Tétel mentése" icon="pi pi-plus" className="p-button-success"
                            loading={loading}
                            disabled={!id || !itemFormData.name || (collectionFields && collectionFields[0] && !itemFormData.items)}
                            onClick={() => {
                              const URL = itemScema
                                .replace(/([a-z])([A-Z])/g, '$1-$2')
                                .toLowerCase();
                              setLoading(true);
                              if (itemFormData.item_shortcut_dto_id) {
                                axios.patch(process.env.REACT_APP_API_HOST + "/api/v2/" + URL + '/' + itemFormData.item_shortcut_dto_id,
                                  itemFormData, {
                                    params: {},
                                    headers: {
                                      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                      'App-Network': localStorage.getItem("networkId")
                                    }
                                  })
                                  .then(response => {
                                    window.App.toastShow('success', 'Sikeres mentés!');
                                    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-shortcut-dto/" + id,
                                      {
                                        params: {},
                                        headers: {
                                          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                          'App-Network': localStorage.getItem("networkId")
                                        }
                                      })
                                      .then(response => {
                                        setItems(response.data.data.children_id)
                                        history.push('/project/worksheet/update/' + id)
                                      })
                                      .catch(error => {
                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                      })
                                  })
                                  .catch(error => {
                                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                  })
                                  .finally(() => {
                                    setLoading(false);
                                  })
                              } else {
                                axios.post(process.env.REACT_APP_API_HOST + "/api/v2/" + URL,
                                  itemFormData, {
                                    params: {},
                                    headers: {
                                      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                      'App-Network': localStorage.getItem("networkId")
                                    }
                                  })
                                  .then(response => {
                                    window.App.toastShow('success', 'Sikeres mentés!');
                                    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-shortcut-dto/" + id,
                                      {
                                        params: {},
                                        headers: {
                                          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                          'App-Network': localStorage.getItem("networkId")
                                        }
                                      })
                                      .then(response => {
                                        setItems(response.data.data.children_id)
                                        history.push('/project/worksheet/update/' + id)
                                      })
                                      .catch(error => {
                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                      })
                                  })
                                  .catch(error => {
                                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                  })
                                  .finally(() => {
                                    setLoading(false);
                                  })
                              }
                            }}
                    />
                  </div>
                </div>
              </Dialog>
            </Panel>
          }
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(WorksheetFormComponent);
